import "./Costs.module.css";
import Header from "@/reusable_sections/Header";
import ProceduresAndHseReimbursement from "./sections/ProceduresAndHseReimbursement";
import AdditionalCostsNotCoveredByHse from "./sections/AdditionalCostsNotCoveredByHse";
import EstimatedTotalOutOfPocket from "./sections/EstimatedTotalOutOfPocket";
import Footer from "@/reusable_sections/Footer";
export default function CostsPage() {
  return <div>
      <Header />
      <ProceduresAndHseReimbursement />
      <AdditionalCostsNotCoveredByHse />
      <EstimatedTotalOutOfPocket />
      <Footer />
    </div>;
}